import { FC, memo } from "react";
import MenuExamplesPopup from "@containers/MenuExamplesPopup";
import { useMenuExamplesPopupData } from "@apiHooks/useMenuExamplesPopupData";

interface ByoMenuExamplePopupProps {
    fetch: (options: any) => Promise<any>;
    isShown: boolean;
    close: () => void;
    getExportData: (options: any) => void;
}

const ByoMenuExamplePopup: FC<ByoMenuExamplePopupProps> = ({
    fetch,
    isShown,
    close,
    getExportData,
}) => {
    const {
        download,
        tableData,
        sort,
        getMenuExamples,
        totalCountExamples,
        isLoading,
        handleSortColumn,
        searchQuery,
        handleChangeSearchQuery,
    } = useMenuExamplesPopupData({
        fetch,
        isShown,
        getExportData,
        downloadUrl: 'export byo menu examples'
    });

    return (
        <MenuExamplesPopup
            isShown={isShown}
            close={close}
            download={download}
            tableData={tableData}
            isLoading={isLoading}
            totalCountExamples={totalCountExamples}
            getMenuExamples={getMenuExamples}
            sort={sort}
            handleSortColumn={handleSortColumn}
            searchQuery={searchQuery}
            handleChangeSearchQuery={handleChangeSearchQuery}
        />
    );
};

export default memo(ByoMenuExamplePopup);
